<app-stepper-form
  header="Cease as a Registered Agent in Bulk"
  formIcon="ic-registered-agent-ceasing-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading()"
  [isInvalid]="(currentStep === StepsEnum.Summary && isGridIncludesError) || areAllRowsHaveErrors"
  [form]="stepperForm"
  (stepIndexChange)="onStepChange($event)"
>
  <div
    class="step-content"
    [formGroup]="stepperForm"
    [class]="{'step-content-error': (currentStep === StepsEnum.Summary && isGridIncludesError)}"
  >
    <app-stepper-form-description
      formKey="361"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.RegisteredAgentCeasing"
      [hidden]="currentStep !== StepsEnum.RegisteredAgentCeasing"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Cessation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
        />
      </div>

      <div class="form-group">
        <app-radio
          formControlName="documentationType"
          label="Choose the type of document to generate"
          [options]="documentTypeOptions"
        />
      </div>
    </section>

    <section
      class="step-section"
      [formGroup]="form"
      [hidden]="currentStep !== StepsEnum.Summary"
    >
      <h1 class="h1-heading">Cease as a Registered Agent</h1>

      @if (colDefs.length) {
        <app-list-grid-client-side
          class="bulk-change-grid"
          [rowData]="rows"
          [colDefs]="colDefs"
          [rowSelection]="rowSelection"
          [rowClassRules]="rowClassRules"
          [suppressRowClickSelection]="true"
          [paginationPageSizeSelector]="false"
          [suppressCellFocus]="true"
        />
      }
    </section>
  </div>
</app-stepper-form>
